export interface ComicChapter {
  id: string;
  title: string;
  chapterNum: number;
  updateDate: string;
}

export interface ComicData {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  description: string;
  updateDate: string;
  chapters: ComicChapter[];
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'bl', name: '耽美', icon: 'ri-star-smile-line' },
];

export const comicList: ComicData[] = [
  {
    id: 'comic-1',
    title: '我独自升级',
    author: 'Chugong / Dubu',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20powerful%20male%20hunter%20with%20dark%20hair%20and%20glowing%20blue%20eyes%20standing%20in%20a%20dungeon%2C%20dark%20atmospheric%20background%20with%20shadows%2C%20epic%20fantasy%20illustration%2C%20clean%20composition%2C%20professional%20manhwa%20cover%20design&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'love',
    tags: ['战斗', '奇幻', '升级流'],
    status: '连载中',
    rating: 9.7,
    views: 15280000,
    description: '十年前，世界各地突然出现了连接异次元的"传送门"，而能够进入传送门讨伐其中魔物的人被称作"猎人"。然而，并非所有猎人都实力超群。故事的主角程肖宇，是韩国最弱的E级猎人，在一次 raid 中濒死之际，意外获得了能够无限升级的特殊能力。',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch1-1', title: '第200话 - 最终之战（三）', chapterNum: 200, updateDate: '2026-08-05' },
      { id: 'ch1-2', title: '第199话 - 最终之战（二）', chapterNum: 199, updateDate: '2026-08-01' },
      { id: 'ch1-3', title: '第198话 - 最终之战（一）', chapterNum: 198, updateDate: '2026-07-28' },
    ],
  },
  {
    id: 'comic-2',
    title: '女神降临',
    author: '喵喵',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20beautiful%20young%20woman%20with%20long%20brown%20hair%20and%20flawless%20makeup%2C%20soft%20romantic%20atmosphere%2C%20pastel%20background%20with%20cherry%20blossoms%2C%20shojo%20manga%20style%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'love',
    tags: ['恋爱', '校园', '化妆'],
    status: '已完结',
    rating: 9.3,
    views: 23500000,
    description: '从小就因为外貌被欺凌的林周京，在转学后通过神奇的化妆术变成了校园女神。但她的素颜秘密却被全校最帅的两个男生发现了，一个是冷酷学霸李修豪，另一个是阳光校草韩书俊。一段关于外貌与真心的青春爱情故事就此展开。',
    updateDate: '2026-07-20',
    chapters: [
      { id: 'ch2-1', title: '第256话 - 最终话', chapterNum: 256, updateDate: '2026-07-20' },
      { id: 'ch2-2', title: '第255话 - 告白', chapterNum: 255, updateDate: '2026-07-16' },
      { id: 'ch2-3', title: '第254话 - 选择', chapterNum: 254, updateDate: '2026-07-12' },
    ],
  },
  {
    id: 'comic-3',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20young%20man%20reading%20a%20glowing%20book%20in%20an%20apocalyptic%20cityscape%2C%20fantasy%20and%20sci-fi%20elements%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'fantasy',
    tags: ['穿越', '末世', '系统流'],
    status: '连载中',
    rating: 9.6,
    views: 18900000,
    description: '金独子是唯一一个读完一部连载了3149话的网络小说《在灭亡的世界中生存的三种方法》的读者。在小说完结的那一天，他收到了作者发来的邮件，而小说中的世界竟变成了现实。作为唯一知道结局的人，金独子能否改变这个世界的命运？',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch3-1', title: '第230话 - 新的开始', chapterNum: 230, updateDate: '2026-08-04' },
      { id: 'ch3-2', title: '第229话 - 星流的真相', chapterNum: 229, updateDate: '2026-07-31' },
      { id: 'ch3-3', title: '第228话 - 最后的星座', chapterNum: 228, updateDate: '2026-07-28' },
    ],
  },
  {
    id: 'comic-4',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20cute%20princess%20with%20blonde%20hair%20and%20sparkling%20blue%20eyes%20in%20an%20elegant%20dress%2C%20royal%20palace%20background%20with%20golden%20decorations%2C%20fairy%20tale%20atmosphere%2C%20beautiful%20fantasy%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'fantasy',
    tags: ['穿越', '皇室', '治愈'],
    status: '连载中',
    rating: 9.4,
    views: 12700000,
    description: '一个普通女孩穿越成了小说中的公主——但是是一个注定要被自己亲生父亲杀死的悲惨公主。为了活下来，她必须想尽办法获得那位冷酷皇帝父亲的爱。一位史上最可爱的公主的生存记就此开始！',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch4-1', title: '第125话 - 生日宴会', chapterNum: 125, updateDate: '2026-08-03' },
      { id: 'ch4-2', title: '第124话 - 父女时光', chapterNum: 124, updateDate: '2026-07-30' },
      { id: 'ch4-3', title: '第123话 - 帝国庆典', chapterNum: 123, updateDate: '2026-07-27' },
    ],
  },
  {
    id: 'comic-5',
    title: '神之塔',
    author: 'SIU',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20boy%20climbing%20a%20mysterious%20towering%20structure%20reaching%20into%20the%20sky%2C%20fantasy%20adventure%2C%20dramatic%20perspective%2C%20epic%20scale%2C%20clean%20and%20detailed%20illustration&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'action',
    tags: ['冒险', '战斗', '奇幻'],
    status: '连载中',
    rating: 9.5,
    views: 20100000,
    description: '二十五夜为了追寻唯一的朋友蕾哈尔，进入了传说中的"神之塔"。塔的每一层都是一个世界，只有通过试炼才能向上攀登。只要到达塔顶，就能获得任何想要的东西——财富、权力、甚至是神的力量。',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch5-1', title: '第580话 - 塔顶的真相', chapterNum: 580, updateDate: '2026-08-05' },
      { id: 'ch5-2', title: '第579话 - 吉黑德的秘密', chapterNum: 579, updateDate: '2026-08-02' },
      { id: 'ch5-3', title: '第578话 - 新的联盟', chapterNum: 578, updateDate: '2026-07-30' },
    ],
  },
  {
    id: 'comic-6',
    title: '恶女的定义',
    author: 'Yen / Catty',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20beautiful%20noblewoman%20with%20dark%20red%20hair%20and%20sharp%20eyes%20holding%20a%20fan%2C%20luxurious%20Victorian%20era%20ballroom%20background%2C%20dramatic%20romance%20atmosphere%2C%20elegant%20illustration&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'drama',
    tags: ['宫廷', '复仇', '权谋'],
    status: '连载中',
    rating: 9.2,
    views: 9800000,
    description: '穿越到了小说中注定要被处死的恶女配角身上，但这次她不会再按照原著的剧本走了。凭借对剧情的了解和对人心的洞察，她开始了一场惊心动魄的宫廷权力游戏。',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch6-1', title: '第88话 - 皇后的阴谋', chapterNum: 88, updateDate: '2026-08-04' },
      { id: 'ch6-2', title: '第87话 - 舞会之夜', chapterNum: 87, updateDate: '2026-07-31' },
      { id: 'ch6-3', title: '第86话 - 暗中较量', chapterNum: 86, updateDate: '2026-07-28' },
    ],
  },
  {
    id: 'comic-7',
    title: '看脸时代',
    author: '朴泰俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20split%20face%20showing%20an%20overweight%20teenager%20on%20one%20side%20and%20a%20handsome%20fit%20teenager%20on%20the%20other%2C%20school%20background%2C%20social%20commentary%20theme%2C%20dramatic%20contrast%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'drama',
    tags: ['校园', '社会', '成长'],
    status: '连载中',
    rating: 9.1,
    views: 31500000,
    description: '朴亨硕是一个因为肥胖外貌而遭受校园霸凌的高中生。转学后某天醒来，他发现自己拥有了另一副完美身躯。白天是帅气型男，晚上是原来的自己。通过两副身体，他看到了这个"看脸时代"中截然不同的两个世界。',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch7-1', title: '第470话 - 四大帮派', chapterNum: 470, updateDate: '2026-08-05' },
      { id: 'ch7-2', title: '第469话 - 工人登场', chapterNum: 469, updateDate: '2026-08-02' },
      { id: 'ch7-3', title: '第468话 - 联盟破裂', chapterNum: 468, updateDate: '2026-07-30' },
    ],
  },
  {
    id: 'comic-8',
    title: '甜蜜家园',
    author: '金坎比 / 黄英璨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20young%20man%20with%20a%20baseball%20bat%20standing%20in%20a%20dark%20apartment%20corridor%2C%20monster%20silhouettes%20in%20the%20shadows%2C%20horror%20and%20survival%20theme%2C%20tense%20atmosphere%2C%20professional%20illustration&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'suspense',
    tags: ['恐怖', '生存', '怪物'],
    status: '已完结',
    rating: 9.4,
    views: 16800000,
    description: '车贤秀在失去家人后搬到了一栋破旧的公寓楼，准备结束自己的生命。然而，怪物末日突然降临——人类的欲望会将人变成可怕的怪物。贤秀和公寓的幸存者们必须团结起来，在这场恶梦中拼死求生。',
    updateDate: '2026-06-15',
    chapters: [
      { id: 'ch8-1', title: '第141话 - 终章', chapterNum: 141, updateDate: '2026-06-15' },
      { id: 'ch8-2', title: '第140话 - 最后的抉择', chapterNum: 140, updateDate: '2026-06-11' },
      { id: 'ch8-3', title: '第139话 - 牺牲', chapterNum: 139, updateDate: '2026-06-07' },
    ],
  },
  {
    id: 'comic-9',
    title: '剑尊归来',
    author: 'LEE Gwang-Su',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20swordsman%20in%20traditional%20Korean%20martial%20arts%20robe%20holding%20a%20glowing%20sword%2C%20mountain%20landscape%20with%20cherry%20blossoms%2C%20martial%20arts%20cultivation%20theme%2C%20epic%20wuxia%20style%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: 'action',
    tags: ['武侠', '重生', '热血'],
    status: '连载中',
    rating: 9.5,
    views: 11300000,
    description: '一代剑尊在飞升之际被背叛陨落，却意外回到了少年时代。带着前世的记忆和武学境界，他决心弥补遗憾，保护珍视之人，踏上一条不同的武道巅峰之路。曾经的天才剑客，如今归来仍是少年！',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch9-1', title: '第95话 - 剑意大成', chapterNum: 95, updateDate: '2026-08-04' },
      { id: 'ch9-2', title: '第94话 - 前辈的考验', chapterNum: 94, updateDate: '2026-07-31' },
      { id: 'ch9-3', title: '第93话 - 武斗大会', chapterNum: 93, updateDate: '2026-07-28' },
    ],
  },
  {
    id: 'comic-10',
    title: '入学暴徒',
    author: '金圭森',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20tough%20looking%20high%20school%20student%20with%20dyed%20hair%20in%20school%20uniform%2C%20urban%20street%20background%2C%20action%20and%20fighting%20theme%2C%20gritty%20realistic%20style%2C%20dynamic%20pose&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: 'action',
    tags: ['校园', '格斗', '犯罪'],
    status: '连载中',
    rating: 9.0,
    views: 8900000,
    description: '金基明是一个从不惹事但也不怕事的转学生。他来到了一所被暴力统治的高中，这里的秩序由几个帮派掌控。为了守护朋友和正义，他不得不以暴制暴，用自己的双拳打出一片天地。',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch10-1', title: '第110话 - 最后的对决', chapterNum: 110, updateDate: '2026-08-03' },
      { id: 'ch10-2', title: '第109话 - 幕后黑手', chapterNum: 109, updateDate: '2026-07-30' },
      { id: 'ch10-3', title: '第108话 - 援军', chapterNum: 108, updateDate: '2026-07-27' },
    ],
  },
  {
    id: 'comic-11',
    title: '痞子学霸',
    author: '金龙熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20tough%20but%20intelligent%20looking%20student%20reading%20a%20book%20while%20leaning%20against%20a%20school%20wall%2C%20contrast%20between%20academics%20and%20street%20life%2C%20urban%20school%20setting%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: 'comedy',
    tags: ['校园', '搞笑', '逆袭'],
    status: '连载中',
    rating: 9.2,
    views: 7600000,
    description: '全校最凶的混混竟然考了年级第一？所有人都以为他作弊了，但没人知道他每天晚上都在偷偷学习。当学霸的秘密被校花发现后，一段啼笑皆非的校园生活开始了。',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch11-1', title: '第62话 - 期末考试', chapterNum: 62, updateDate: '2026-08-05' },
      { id: 'ch11-2', title: '第61话 - 补习班', chapterNum: 61, updateDate: '2026-08-01' },
      { id: 'ch11-3', title: '第60话 - 冤家路窄', chapterNum: 60, updateDate: '2026-07-28' },
    ],
  },
  {
    id: 'comic-12',
    title: '极道少女',
    author: '林达浪',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20cool%20female%20fighter%20with%20short%20hair%20and%20leather%20jacket%2C%20neon-lit%20city%20streets%20at%20night%2C%20action%20and%20underworld%20theme%2C%20strong%20female%20lead%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: 'action',
    tags: ['黑帮', '女强', '热血'],
    status: '连载中',
    rating: 9.1,
    views: 6500000,
    description: '作为韩国最大帮派"白虎帮"帮主的独生女，姜夏琳从小就在刀光剑影中长大。父亲去世后，她被迫接过帮主的重担，面对内忧外患，她必须用自己的方式证明——谁说女子不如男。',
    updateDate: '2026-08-02',
    chapters: [
      { id: 'ch12-1', title: '第78话 - 帮主之战', chapterNum: 78, updateDate: '2026-08-02' },
      { id: 'ch12-2', title: '第77话 - 内部叛变', chapterNum: 77, updateDate: '2026-07-29' },
      { id: 'ch12-3', title: '第76话 - 新的盟友', chapterNum: 76, updateDate: '2026-07-26' },
    ],
  },
  {
    id: 'comic-13',
    title: '公爵的契约未婚妻',
    author: 'Milcha / WHALE',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20an%20elegant%20woman%20in%20a%20flowing%20gown%20standing%20with%20a%20cold%20duke%20in%20a%20grand%20mansion%2C%20contract%20marriage%20romance%20theme%2C%20victorian%20era%20aesthetic%2C%20beautiful%20fantasy%20illustration&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    category: 'love',
    tags: ['契约婚姻', '贵族', '浪漫'],
    status: '连载中',
    rating: 9.3,
    views: 14500000,
    description: '穿越成为小说中即将被丈夫毒死的配角，为了活命，她向北方最可怕的大公爵提出了一个交易——成为他的契约未婚妻。她以为这只是一场各取所需的交易，却没想到冷酷的大公爵竟对她越来越在意。',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch13-1', title: '第145话 - 真心的告白', chapterNum: 145, updateDate: '2026-08-05' },
      { id: 'ch13-2', title: '第144话 - 舞会风波', chapterNum: 144, updateDate: '2026-08-01' },
      { id: 'ch13-3', title: '第143话 - 公爵的秘密', chapterNum: 143, updateDate: '2026-07-28' },
    ],
  },
  {
    id: 'comic-14',
    title: '我的ID是江南美人',
    author: '淇萌',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20beautiful%20college%20girl%20with%20natural%20looking%20makeup%20on%20a%20university%20campus%2C%20romantic%20comedy%20vibe%2C%20soft%20lighting%2C%20modern%20Seoul%20setting%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    category: 'love',
    tags: ['校园', '整容', '恋爱'],
    status: '已完结',
    rating: 9.0,
    views: 18200000,
    description: '姜美来因为外貌从小被嘲笑，在大学入学前做了整容手术，变成了人人称赞的"江南美人"。但她很快发现，外貌的改变并没有解决所有问题。在校园里，她遇到了知道她过去的中学同学都炅锡……',
    updateDate: '2026-05-30',
    chapters: [
      { id: 'ch14-1', title: '第205话 - 幸福的结局', chapterNum: 205, updateDate: '2026-05-30' },
      { id: 'ch14-2', title: '第204话 - 求婚', chapterNum: 204, updateDate: '2026-05-26' },
      { id: 'ch14-3', title: '第203话 - 毕业季', chapterNum: 203, updateDate: '2026-05-22' },
    ],
  },
  {
    id: 'comic-15',
    title: '重生为英雄的女儿',
    author: 'Yooani / Moogi',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20young%20girl%20with%20silver%20hair%20and%20magical%20aura%2C%20surrounded%20by%20legendary%20heroes%20in%20a%20fantasy%20world%2C%20adventure%20and%20family%20theme%2C%20warm%20and%20epic%20atmosphere%2C%20beautiful%20illustration&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    category: 'fantasy',
    tags: ['异世界', '亲情', '冒险'],
    status: '连载中',
    rating: 9.4,
    views: 10500000,
    description: '一个普通的上班族在一场事故中丧生，醒来后发现自己变成了一个婴儿——而且还是传说中的英雄们的女儿！在这个剑与魔法的世界里，她凭借前世的记忆和知识，展开了一段温馨又刺激的冒险。',
    updateDate: '2026-08-03',
    chapters: [
      { id: 'ch15-1', title: '第98话 - 觉醒的力量', chapterNum: 98, updateDate: '2026-08-03' },
      { id: 'ch15-2', title: '第97话 - 魔王的威胁', chapterNum: 97, updateDate: '2026-07-30' },
      { id: 'ch15-3', title: '第96话 - 勇者的训练', chapterNum: 96, updateDate: '2026-07-27' },
    ],
  },
  {
    id: 'comic-16',
    title: '废柴重生',
    author: '尹贤书',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20determined%20young%20man%20with%20shaggy%20hair%20rising%20from%20defeat%2C%20training%20montage%20vibe%2C%20martial%20arts%20and%20self-improvement%20theme%2C%20gritty%20and%20inspiring%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    category: 'action',
    tags: ['重生', '复仇', '逆袭'],
    status: '连载中',
    rating: 8.9,
    views: 7200000,
    description: '被陷害入狱十年后，曾经的格斗天才郑太一重获自由。世界已经天翻地覆，但他体内流淌的格斗之血从未冷却。他要向那些毁了他人生的人复仇，更要夺回属于自己的尊严和荣耀。',
    updateDate: '2026-08-04',
    chapters: [
      { id: 'ch16-1', title: '第55话 - 地下格斗', chapterNum: 55, updateDate: '2026-08-04' },
      { id: 'ch16-2', title: '第54话 - 真相浮现', chapterNum: 54, updateDate: '2026-07-31' },
      { id: 'ch16-3', title: '第53话 - 老友重逢', chapterNum: 53, updateDate: '2026-07-28' },
    ],
  },
  {
    id: 'comic-17',
    title: '她的私生活',
    author: '金成妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20professional%20woman%20in%20office%20attire%20secretly%20holding%20idol%20merchandise%20behind%20her%20back%2C%20dual%20life%20comedy%20theme%2C%20modern%20Seoul%20office%20setting%2C%20fun%20and%20relatable%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-17&orientation=portrait',
    category: 'comedy',
    tags: ['职场', '追星', '恋爱'],
    status: '已完结',
    rating: 9.1,
    views: 13400000,
    description: '成德美白天是美术馆的首席策展人，晚上却是偶像团体"白色告白"的狂热粉丝。她的双重生活一直隐藏得很好，直到新来的馆长——前偶像成员Ryan Gold走进了她的生活，一切开始变得混乱又有趣。',
    updateDate: '2026-04-20',
    chapters: [
      { id: 'ch17-1', title: '第158话 - 最终话', chapterNum: 158, updateDate: '2026-04-20' },
      { id: 'ch17-2', title: '第157话 - 公开的秘密', chapterNum: 157, updateDate: '2026-04-16' },
      { id: 'ch17-3', title: '第156话 - 粉丝见面会', chapterNum: 156, updateDate: '2026-04-12' },
    ],
  },
  {
    id: 'comic-18',
    title: '契约婚姻',
    author: '李海娜',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20couple%20signing%20a%20contract%20in%20a%20luxurious%20apartment%2C%20fake%20marriage%20romance%20theme%2C%20modern%20and%20elegant%2C%20warm%20romantic%20atmosphere%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-18&orientation=portrait',
    category: 'love',
    tags: ['契约婚姻', '大企业', '甜宠'],
    status: '连载中',
    rating: 9.2,
    views: 9600000,
    description: '为了挽救即将破产的家族企业，她被安排与全国最富有但也最冷酷的男人签订契约婚姻。她以为这只是一场维持一年的交易，却发现自己不知不觉间已经陷入了这段虚假却不失甜蜜的婚姻之中。',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch18-1', title: '第82话 - 真心还是契约', chapterNum: 82, updateDate: '2026-08-05' },
      { id: 'ch18-2', title: '第81话 - 家族宴会', chapterNum: 81, updateDate: '2026-08-01' },
      { id: 'ch18-3', title: '第80话 - 意外的吻', chapterNum: 80, updateDate: '2026-07-28' },
    ],
  },
  {
    id: 'comic-19',
    title: '大贵族',
    author: '孙齐皓 / 李光洙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20noble%20vampire%20with%20silver%20hair%20and%20red%20eyes%20in%20a%20modern%20school%20uniform%2C%20supernatural%20action%20theme%2C%20dark%20gothic%20elements%20mixed%20with%20modern%20setting%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-19&orientation=portrait',
    category: 'action',
    tags: ['吸血鬼', '校园', '战斗'],
    status: '已完结',
    rating: 9.3,
    views: 22100000,
    description: '卡迪斯·艾特拉马·迪·莱杰罗，是统治贵族世界的两大贵族之一。在沉睡820年后，他在现代的韩国醒来，以高中生"李"的身份开始了新的生活。但黑暗势力从未放弃对他的追捕。',
    updateDate: '2026-03-10',
    chapters: [
      { id: 'ch19-1', title: '第545话 - 终章', chapterNum: 545, updateDate: '2026-03-10' },
      { id: 'ch19-2', title: '第544话 - 大决战', chapterNum: 544, updateDate: '2026-03-06' },
      { id: 'ch19-3', title: '第543话 - 宿命的对决', chapterNum: 543, updateDate: '2026-03-02' },
    ],
  },
  {
    id: 'comic-20',
    title: '反派小姐的男主人公',
    author: 'Haehwa / RAM',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%2C%20a%20mischievous%20looking%20noblewoman%20with%20pink%20hair%20scheming%20behind%20a%20fan%2C%20comedy%20fantasy%20romance%20theme%2C%20colorful%20and%20whimsical%20atmosphere%2C%20clean%20and%20charming%20illustration&width=600&height=800&seq=comic-cover-20&orientation=portrait',
    category: 'fantasy',
    tags: ['穿越', '搞笑', '浪漫'],
    status: '连载中',
    rating: 9.3,
    views: 11800000,
    description: '穿越成为小说中注定悲剧的反派小姐后，她决定改变剧情——但并不是走善良路线，而是继续当反派，只不过做一个有魅力的反派！然而，原本应该爱上女主角的男主人公们，却一个个被她吸引了过来……',
    updateDate: '2026-08-05',
    chapters: [
      { id: 'ch20-1', title: '第132话 - 意外的告白', chapterNum: 132, updateDate: '2026-08-05' },
      { id: 'ch20-2', title: '第131话 - 帝国舞会', chapterNum: 131, updateDate: '2026-08-01' },
      { id: 'ch20-3', title: '第130话 - 王子驾到', chapterNum: 130, updateDate: '2026-07-28' },
    ],
  },
];

export const categoryMap: Record<string, string> = {
  all: '全部',
  love: '恋爱',
  fantasy: '奇幻',
  action: '动作',
  suspense: '悬疑',
  comedy: '搞笑',
  drama: '剧情',
  bl: '耽美',
};